import React from 'react';
import Grid from '@material-ui/core/Grid';
import Footer from '../common/Footer'
import Slider from 'react-slick'
import mediaQuery from '../common/mediaQuery'
import { FontAwesome } from 'react-web-vector-icons'
// estilos
import { Text, GreenText, Button } from '../common/styled'
import './style.css';
import ScrollAnimation from 'react-animate-on-scroll'
import employees from './components/employees'
import { SampleNextArrow, SamplePrevArrow } from '../common/Arrows'

export default ({ text, language, routeChange }) => {

  const { small } = mediaQuery()

  const settings = {
    dots: true,
    infinite: false,
    speed: 600,
    pauseOnHover: true,
    arrows: true,
    draggable: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    autoplay: false,
    autoplaySpeed: 1000,
    slidesToShow: small ? 1 : 4,
    slidesToScroll: small ? 1 : 1,
    className: "EmployeeSlider",
    appendDots: dots => <ul>{dots}</ul>
};

  return (
    <div className="Body-wrapper">
      <Grid container justify="center" alignItems="center" className="Body-section1" style={ { paddingRight: '75vw' } }>
        <Grid item xs={7} sm={8} justify="center" alignItems="center" style={ { display: "inline" } }>
          <ScrollAnimation animateIn="bounceInRight" animateOnce={true}>
            <Text style={ { width: '90vw' } } lineHeight="1.7" size={small ? "2.5vh" : "2.2vw"} weight="600" align="center" break="">
              { text.getTextoHome1() }
              <GreenText lineHeight="1.7" size={small ? "2.2vh" : "2.2vw"} weight="600" color="#58b711" align="center">City Connect</GreenText>
              { text.getTextoHome2() }
            </Text>
          </ScrollAnimation>
        </Grid>
      </Grid>

      {/* <Grid container justify="center" alignItems="center" alignContent="center" 
      className="Body-section2" style={ { marginBottom: '6vh'}}>
        <Grid item xs={7} sm={8} style={ { display: "inline", marginBottom: '3vh' } }>
            <Text size="6vh" transform="uppercase" weight="900" style={ { borderBottom: 'solid', borderWidth: 3,  
            borderColor: "#58b711", paddingBottom: 2 } } 
            align="center" color="#222">{ text.getTextoEquipe() }</Text>
        </Grid>
        <Grid item xs={small ? 12 : 12} sm={12} justify="center" 
        style={ { marginBottom: '3vh'} }>
          
          <div className="SlideEmployeeContainer">
            <Slider {...settings}>
            { employees.map(employee => {
                    return (   
                      <div style={ { display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                        <div className={small ? "employeeSlideMobile" : "employeeSlide"}>
                            <div 
                              className={small ? "slidePicContainerMobile" : "slidePicContainer"}
                              style={{ backgroundImage: `url(${employee.image})` }}
                            />
                            <div className="LinkedinContainer">
                              <div className={small ? "nameContainerMobile" : "nameContainer"}>
                                <Text
                                  align="center"
                                  color="#222"
                                  weight="600" 
                                  size={small ? "3.2vh" : "1.3vw"}
                                >
                                  {employee.nome}
                                </Text>
                              </div>

                              <div className={small ? "linkedinPicMobile" : "linkedinPic"}>
                                <a href={employee.linkedin} target="_blank">
                                  <img
                                    className={small ? "linkedinMobile" : "linkedin"}
                                    src={require('../../images/quem_somos/linkedin.png')}
                                    alt="linkedin"
                                  />
                                </a>
                              </div>
                            </div>
                        </div>
                      </div>     
                    )
              })
            }           
            </Slider>
          </div>
        </Grid>
      </Grid> */}

      <div class={small ? "Body-section-3-mobile" : "Body-section-3"}>
        <div style={small ? { width: '43%' } : { width: '50%' }} />

        <div className={small ? 'contentContainerMobile' : 'contentContainer'}>
          <Text 
            align="left"
            color="#fff"
            weight="900" 
            size={small ? "1.7vh" : "2vw"}
          >
            {text.getLastText()}
          </Text>

          <Button 
            onClick={() => routeChange("portifolio")} 
            width={small ? "23vh" : "25vh"} className={small ? 'SeePortfolioBtnMobile' : 'SeePortfolioBtn'}
            padding={small ? "1px" : "5px"}
            height={small ? "7vh" : ""}
          >
            {text.getBtnText()}
          </Button>
        </div>
      </div>
      <Footer text={ text } language={ language } />
    </div>
  )
}